<script setup lang="ts">
const props = defineProps({
  isVisible: Boolean,
  selectedKeyId: Number,
  title: String,
  message: String,
  deleteFunction: Function,
})
const emit = defineEmits(['updateKeys', 'closeModal'])
const handleDelete = async () => {
  if (props.selectedKeyId !== null && props.deleteFunction) {
    try {
      const success = await props.deleteFunction(props.selectedKeyId)
      if (success)
        emit('updateKeys')
    }
    catch (error) {
      console.error('Failed to delete API Key:', error)
    }
    finally {
      emit('closeModal')
    }
  }
}

const closeModal = () => {
  emit('closeModal')
}
</script>

<template>
  <div v-if="props.isVisible" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white p-4 rounded-lg shadow-md">
      <h2 class="text-lg font-semibold mb-4">
        {{ props.title }}
      </h2>
      <p>{{ props.message }}</p>
      <div class="mt-4 flex justify-end">
        <AppButton
          variant="clear" type="button" class="h-8 md:h-12 !px-4 !md:px-10 <md:flex-1 color-dark-gray"
          @click="closeModal"
        >
          <HeadingV2 level="5" class="!<sm:text-[14px]">
            Cancel
          </HeadingV2>
        </AppButton>

        <AppButton class="group h-8 md:h-12 !px-4 !md:px-10 <md:flex-1" @click="handleDelete">
          <HeadingV2 level="5" class="!<sm:text-[14px] color-white opacity-90 group-hover:opacity-100">
            Delete
          </HeadingV2>
        </AppButton>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fixed {
  position: fixed;
  z-index: 9999;
}
</style>
